
import React from 'react';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import * as actionTypes from '../redux/actionTypes';
import Callable from '../shared/Callable';
import RightIcon from '../_styles/images/Highlight.png';
import userService from '../shared/user-service';


function ThankyouScreen(props) {

  useEffect(() => {
    props.updateLoading(false);
  }, [])

  function goToDashboard() {
    props.updateLoading(true);
    var userProfile = userService.getUserProfile();
    userProfile.isPendingCoordinator = false;
    if (userProfile.isPendingDriver) {
      userProfile.isPendingDriver = false;
      userProfile.isPendingDriverApproval = true;
    }
    props.applicationLoader(true);
    setTimeout(() => {
      props.setRefresh(true);
      props.setUseAuth(userProfile);
      props.history.push("/dashboard");
      props.applicationLoader(false);
    }, 1000);
  }


  return (
    <div className="driver-coordinator-thankyou-page">
      <div className='container'>
        <div className='header'>
          <div className='header-image'>
            <img src={RightIcon} alt='alert' />
          </div>
          <div className='heading'>
            Thank You
          </div>
        </div>
        <div className="pre-text">Your contract/application was submitted, and we will be in touch if we require additional information to complete the process.
        </div>
        <div className='pre-text-2'>
          If you have any questions, please call <Callable className="greentext" phone="800 VAN-4-WORK" />
        </div>
        <div className="button-container">
          <button
            className='continue'
            onClick={goToDashboard}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    updateLoading(data) {
      dispatch({ type: actionTypes.LOADER_ACTIVE, data });
    },
    setRefresh(refresh) {
      dispatch({ type: actionTypes.SET_REFRESH_DASHBOARD, refresh });
    },
    setUseAuth(userProfile) {
      dispatch({ type: actionTypes.SET_USER_AUTHORIZATION, data: userProfile });
    },
    applicationLoader(data){
      dispatch({ type: actionTypes.START_APPLICATION_LOADER, data });
    }
    
  };
}

export default connect(null, mapDispatchToProps)(ThankyouScreen);
